import api from './api';

const folderService = {
  // Get all folders
  getFolders: async (parentId = null) => {
    const params = parentId ? { parentId } : {};
    const response = await api.get('/folders', { params });
    return response.data;
  },

  // Get all folders for move dialog
  getAllFolders: async () => {
    const response = await api.get('/folders/all');
    return response.data;
  },

  // Create folder
  createFolder: async (name, parentId = null) => {
    const response = await api.post('/folders', { name, parentId });
    return response.data;
  },

  // Delete folder
  deleteFolder: async (folderId) => {
    const response = await api.delete(`/folders/${folderId}`);
    return response.data;
  },

  // Rename folder
  renameFolder: async (folderId, newName) => {
    const response = await api.put(`/folders/${folderId}`, { name: newName });
    return response.data;
  },

  // Get folder details
  getFolderDetails: async (folderId) => {
    const response = await api.get(`/folders/${folderId}`);
    return response.data;
  },

  // Upload folder with files
  uploadFolder: async (files, parentId = null, onProgress) => {
    const formData = new FormData();

    // Append all files with their relative paths
    files.forEach(file => {
      formData.append('files', file, file.webkitRelativePath || file.name);
    });

    if (parentId) {
      formData.append('parentId', parentId);
    }

    const response = await api.post('/folders/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (onProgress) {
          onProgress(percentCompleted);
        }
      }
    });

    return response.data;
  },

  // Download folder as ZIP
  downloadFolder: async (folderId, folderName) => {
    const response = await api.get(`/folders/download/${folderId}`, {
      responseType: 'blob'
    });

    // Create a blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${folderName}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  }
};

export default folderService;
